import React, { useState, useEffect, useCallback } from "react";
import { MagicBooks } from "../components/MagicBooks/MagicBooks";
import { Page } from "../components/Page/Page";
import { useGameStore, selectBalance } from "../store/gameStore";

export function MagicBooksPage(): JSX.Element {
  const userBalance = useGameStore(selectBalance);

  // Callback to handle balance updates after book purchases
  const handleBalanceUpdate = useCallback(
    async (newBalance: number) => {
      // Update balance in store
      useGameStore.getState().updateBalance(newBalance);

      // Also refresh user data from server to keep it in sync
      // This ensures the balance is accurate for other parts of the app
      try {
        await useGameStore.getState().refreshUserData();
      } catch (error) {
        console.error(
          "Failed to refresh user data after book purchase:",
          error
        );
        // Keep the local balance update even if server refresh fails
      }
    },
    []
  );

  return (
    <Page>
      <MagicBooks
        userBalance={userBalance}
        onBalanceUpdate={handleBalanceUpdate}
      />
    </Page>
  );
}
